<template>
  <span
    v-if="hasError && (!this.validationFunction.showMessage() || !isFocused)"
    :class="
      '_helper_gjts0_117 text-sm ' +
      [this.validationFunction.isWarning() ? 'alert' : 'danger']
    "
  >
    {{ error }}
  </span>
  <span
    v-else-if="!hasError && this.validationFunction.showMessage() && isFocused"
    class="_helper_gjts0_117 primary text-sm"
  >
    {{ this.validationFunction.getMessage() }}
  </span>
  <span
    v-else-if="hasError && this.validationFunction.showMessage() && isFocused"
    class="_helper_gjts0_117 secondary text-sm"
  >
    {{ this.validationFunction.getMessage() }}
  </span>
</template>

<script>
export default {
  data() {
    return {
      error: '',
      hasError: false
    }
  },
  props: {
    validationFunction: {
      type: Function,
      required: true
    },
    isFocused: {
      default: false
    },
    label: {
      default: ''
    }
  },
  methods: {
    validate(value) {
      this.clearError()
      try {
        this.validationFunction(this.label, value)
      } catch (ex) {
        this.setError(ex.message)
      }
    },
    isValid(value) {
      this.validate(value)
      return !this.hasError
    },
    setError(message) {
      this.error = message
      this.hasError = true
    },
    clearError() {
      this.hasError = false
      this.error = ''
    }
  }
}
</script>
